import { type WidgetUIRuntimeProps } from '@subscan/widget-runtime';
import { SubscanLib } from 'widgets/lib';
const libs = [SubscanLib];

export default {
  libs,
} as WidgetUIRuntimeProps;
